import { useState } from 'react';
import { Modal } from '../ui/Modal.jsx';
import { documentsApi, documentLabel } from '../../api/documents.js';

// Flux „Am reînnoit X": marchează documentul curent ca rezolvat + creează unul nou
// cu aceeași mașină și același tip. Data emitere default = azi. Fișier opțional.
export function RenewForm({ open, onClose, document: doc, onRenewed }) {
  const [dataEmitere, setDataEmitere] = useState(new Date().toISOString().slice(0, 10));
  const [dataExpirare, setDataExpirare] = useState('');
  const [observatii, setObservatii] = useState('');
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  async function onSubmit(e) {
    e.preventDefault();
    if (!dataExpirare) {
      setErr('Data de expirare este obligatorie.');
      return;
    }
    setErr('');
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('data_expirare', dataExpirare);
      if (dataEmitere) fd.append('data_emitere', dataEmitere);
      if (observatii) fd.append('observatii', observatii);
      if (file) fd.append('fisier', file);

      const res = await documentsApi.renew(doc.id, fd);
      onRenewed?.(res.document);
      onClose?.();
    } catch (ex) {
      if (ex.body?.error === 'already_resolved') setErr('Documentul e deja rezolvat.');
      else if (ex.body?.error === 'invalid_mime') setErr('Fișier invalid — doar PDF, JPEG sau PNG.');
      else if (ex.body?.error === 'file_too_large') setErr('Fișier peste 10MB.');
      else setErr(ex.body?.error || 'Eroare.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal open={open} onClose={onClose} title={`Am reînnoit ${documentLabel(doc?.tip)}`}>
      <form onSubmit={onSubmit} className="space-y-4">
        <p className="text-sm text-muted">
          Documentul anterior se marchează ca rezolvat și se creează unul nou. Alertele se opresc automat.
        </p>

        {err && <div className="rounded-lg border border-danger/30 bg-danger/10 px-3 py-2 text-sm text-danger">{err}</div>}

        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <span className="text-xs font-semibold uppercase tracking-wider text-muted">Data emitere</span>
            <input
              type="date"
              value={dataEmitere}
              onChange={(e) => setDataEmitere(e.target.value)}
              className="mt-1 w-full rounded-lg border border-border bg-paper px-3 py-2.5 focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20"
            />
          </label>
          <label className="block">
            <span className="text-xs font-semibold uppercase tracking-wider text-muted">Data expirare *</span>
            <input
              type="date"
              required
              value={dataExpirare}
              onChange={(e) => setDataExpirare(e.target.value)}
              className="mt-1 w-full rounded-lg border border-border bg-paper px-3 py-2.5 focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20"
            />
          </label>
        </div>

        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted">Observații (opțional)</span>
          <input
            value={observatii}
            onChange={(e) => setObservatii(e.target.value)}
            className="mt-1 w-full rounded-lg border border-border bg-paper px-3 py-2.5 focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20"
          />
        </label>

        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted">Document nou (opțional)</span>
          <input
            type="file"
            accept="application/pdf,image/jpeg,image/png"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            className="mt-1 block text-sm"
          />
        </label>

        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="btn-ghost">Anulează</button>
          <button type="submit" disabled={busy} className="btn-primary">
            {busy ? 'Se salvează…' : 'Confirmă reînnoirea'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
